import React, { useMemo, useContext } from "react";
import { Flex } from "reflexbox";
import { Body } from "../UI/Text";
import formatter from "../../modules/formatter";
import { useTheme } from "styled-components";
import UserContext from "../../context/user/UserContext";

const PriceDisplay = ({ row, isDealer, isPlane, isUnit }) => {
	const { activeUser } = useContext(UserContext);

	const theme = useTheme();
	const { price, Details: d, dealerPrice, quantity, id } = row || {};
	let discountPrice = dealerPrice || 0;

	const { discountPercentage, defaultPrice, ProductNumber } = row || {};
	if (!!ProductNumber) {
		discountPrice = defaultPrice * ((discountPercentage * -1) / 100);
	}

	if (!!isDealer && !!isPlane && !ProductNumber) {
		const Details = d || []; //JSON.parse(d || "[]");
		Details.forEach((Detail, i) => {
			const { Value, Caption: _Caption } = Detail || {};

			const isDEALER = _Caption.startsWith("DEALER");
			const isMSRP = _Caption.startsWith("MSRP");

			if (!isMSRP && !isDEALER) return;
			if (Value === "***INCLUDED***") return;

			const val = Value.replace(/[^\p{L}0-9]/g, "") / 100;

			if (isDealer) {
				if (isDEALER) {
					discountPrice += val;
				}
			}
		});
	}

	const display = useMemo(() => {
		if (isDealer)
			return (
				<>
					{activeUser?.roleLevel !== 0 && (
						<>
							<Body linethrough right>
								${formatter.currency(price * (isUnit ? 1 : quantity))}
							</Body>

							<Body color={theme.secondary} right>
								$
								{formatter.currency(
									isPlane
										? +discountPrice * (isUnit ? 1 : quantity)
										: (price - discountPrice) * (isUnit ? 1 : quantity)
								)}
							</Body>
						</>
					)}

					{activeUser?.roleLevel === 0 && (
						<Body right>
							${formatter.currency(price * (isUnit ? 1 : quantity))}
						</Body>
					)}
				</>
			);
		return (
			<Body right>${formatter.currency(price * (isUnit ? 1 : quantity))}</Body>
		);
	}, [
		activeUser,
		discountPrice,
		isDealer,
		isPlane,
		isUnit,
		price,
		quantity,
		theme.secondary,
	]);

	return (
		<Flex
			height="100%"
			justifyContent={isDealer ? "center" : "flex-end"}
			alignItems="center"
			flexWrap="wrap"
			key={id + "|price"}
		>
			{display}
		</Flex>
	);
};

export default PriceDisplay;
